import React from 'react';
import PillarCard from './PillarCard';

function FocusDetail({ area }) {
  return (
    <div className="focus-detail" id={area.id}>
      <div className="focus-detail-header reveal">
        <h2 className="focus-detail-title">{area.title}</h2>
        <p className="focus-detail-subtitle">{area.subtitle}</p>
      </div>
      <p className="focus-detail-intro reveal">{area.intro}</p>

      {area.sectionTitle && (
        <h3 className="focus-detail-section-title reveal">{area.sectionTitle}</h3>
      )}
      {area.sectionDesc && (
        <p className="focus-detail-desc reveal">{area.sectionDesc}</p>
      )}

      <div className="pillar-grid">
        {area.pillars.map((p, i) => (
          <PillarCard key={p.title} title={p.title} text={p.text} index={i} />
        ))}
      </div>

      <ApproachBlock area={area} />
    </div>
  );
}

function ApproachBlock({ area }) {
  return (
    <div className="focus-approach reveal">
      <div className="focus-approach-card">
        <h4>Our Approach</h4>
        <p>{area.approach}</p>
      </div>
      <div className="focus-approach-card join">
        <h4>Join Us</h4>
        <p>{area.joinUs}</p>
      </div>
    </div>
  );
}

export default FocusDetail;
